<script lang="ts" setup>
import { computed, ref } from 'vue';
import { useApplicationRoot } from '@tools/applicationRoot';
import VButton, { type VButtonProps } from '../VButton/VButton.vue';
import VMenu, { type VMenuProps } from '../VMenu/VMenu.vue';

const props = withDefaults(
  defineProps<{
    menuProps: Omit<VMenuProps, 'theme'>;
    buttonProps: VButtonProps;
    menuPosition?: 'above' | 'under';
    appendToRoot?: boolean;
  }>(),
  {
    menuPosition: 'above',
    appendToRoot: false,
  },
);

const menu = ref();
const applicationroot = useApplicationRoot();

const menuOpen = computed(() => !!menu?.value?.overlayVisible());

const appendTo = computed(() => (props.appendToRoot ? applicationroot : 'self'));

const menuClasses = computed(() => {
  if (props.appendToRoot) {
    return '';
  }
  return [
    'left-0!',
    {
      'bottom-full!': props.menuPosition === 'above',
      'top-auto!': props.menuPosition === 'above',
      'top-full!': props.menuPosition === 'under',
      'bottom-auto!': props.menuPosition === 'under',
    },
  ];
});

function toggle(event?: Event | undefined) {
  if (event) menu.value.toggle(event);
}
</script>

<template>
  <div class="relative">
    <VButton
      class="w-full"
      @click="toggle"
      :prepend-icon="
        menuOpen
          ? menuPosition === 'under'
            ? 'fas fa-chevron-up'
            : 'fas fa-chevron-down'
          : menuPosition === 'under'
            ? 'fas fa-chevron-down'
            : 'fas fa-chevron-up'
      "
      v-bind="buttonProps"
    >
      <slot></slot>
    </VButton>
    <VMenu :class="menuClasses" :append-to="appendTo" ref="menu" v-bind="menuProps" popup>
      <template #item="{ item, props }" v-if="$slots.item">
        <slot name="item" :item="item" :props="props"></slot>
      </template>
    </VMenu>
  </div>
</template>
